export default "__VITE_ASSET__7Xwu4y$g__"